const trackOrderForm = document.querySelector('.track-order-form');
const formSubmissionError = document.querySelector('.form-submitted-error');
const loader = document.querySelector('.loader');

let shouldWait = false;

trackOrderForm.addEventListener('submit', (e) => {
  e.preventDefault();
  if (shouldWait) {
    return;
  }
  throttle(checkOrder, 250);
});

window.addEventListener('pageshow', function(event) {
  loader.classList.add('hide');
});

function throttle(cb, delay) { 
  cb();
  shouldWait = true;
  setTimeout(() => {
    shouldWait = false;
  }, delay);
}

async function checkOrder() {
  formSubmissionError.innerHTML = '';
  const orderNumber = document.getElementById('orderNumber').value;
  const email = document.getElementById('email').value;
  window.scrollTo({ top: 0, behavior: 'smooth' });
  loader.classList.remove('hide');
  try {
    const response = await fetch('https://bendavis-track.replit.app/track', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({email, orderNumber})
    });
    const data = await response.json();
    
    if (data.includes('https')) {
      window.location.href = data;
    } else {
      loader.classList.add('hide');
      formSubmissionError.innerHTML = `<p>Order not found </p><span>Please try a different order# or email</span>`
    }
  } catch(error) {
      loader.classList.add('hide');
      formSubmissionError.innerHTML = `<p>Error processing your request</p><span>Please try again later</span>`
  }
}